<template>
	<app-layout />
</template>
<script>
import Layout from "./view/layout/Layout"

export default {
	name: "App",
	components: {
		"app-layout": Layout
	},
	data() {
		return {
			authenticated: false
		}
	}
}
</script>

<style lang="scss">
@import "src/assets/scss/app";
@import "src/assets/scss/vertical-scrollbar";
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
}

.expand {
	margin-left: 200px;
}
.collapsed {
	margin-left: 75px;
}
h2 {
	font-family: "Montserrat", sans-serif;
}

.title {
	h1 {
		font-family: "Montserrat", sans-serif;
	}
	h2 {
		font-family: "Montserrat", sans-serif;
	}
}
</style>
